import { Color, ColorConfig } from '../collections/StatDefinition';
import { Cesium } from '../../cesium';

let configUtilsFile = require('app/config_utils');
// Pull RGB values from config utils
let configUtils = configUtilsFile.configUtils;

export const IMS_LIME: Color = (configUtils as any).IMS_LIME;
export const IMS_RED: Color = (configUtils as any).IMS_RED;
export const IMS_GREEN: Color = (configUtils as any).IMS_GREEN;
export const IMS_BLUE: Color = (configUtils as any).IMS_BLUE;
export const IMS_ORANGE: Color = (configUtils as any).IMS_ORANGE;
export const IMS_ORANGE_RED: Color = (configUtils as any).IMS_ORANGE_RED;
export const IMS_YELLOW: Color = (configUtils as any).IMS_YELLOW;
export const IMS_GOLD: Color = (configUtils as any).IMS_GOLD;
export const IMS_WHITE: Color = (configUtils as any).IMS_WHITE;
export const IMS_BLACK: Color = (configUtils as any).IMS_BLACK;
export const IMS_DIMGREY: Color = (configUtils as any).IMS_DIMGREY;
export const IMS_CLEAR: Color = (configUtils as any).IMS_CLEAR;

export const AVAILABLE_COLORS = {
    Lime: IMS_LIME,
    Red: IMS_RED,
    Green: IMS_GREEN,
    Blue: IMS_BLUE,
    Orange: IMS_ORANGE,
    'Orange Red': IMS_ORANGE_RED,
    Yellow: IMS_YELLOW,
    Gold: IMS_GOLD,
    White: IMS_WHITE,
    Black: IMS_BLACK,
    Dimgrey: IMS_DIMGREY,
    Clear: IMS_CLEAR,
};

export function getImsColorFromName(color: string): Color {
    return AVAILABLE_COLORS[color];
}

export function getImsColorNameFromValue(color: Color): string {
    return Object.keys(AVAILABLE_COLORS).find(
        (key) => JSON.stringify(AVAILABLE_COLORS[key]) === JSON.stringify(color),
    );
}

/**
 * Creates a Cesium.Color object when given a string with either a cesium color name (eg. 'RED') or
 * a CSS color (eg. '#FF0000'), or an array of RGBA values.
 * If given a Cesium.Color object it will pass it straight back without modifying it.
 * @param cesiumColor string value of cesium color
 */
export function createCesiumColorForStrOrArrayColor(cesiumColor): Cesium.Color {
    if (!cesiumColor) {
        return Cesium.Color.WHITE;
    }

    // Handle array colours
    if (Array.isArray(cesiumColor)) {
        const rgba = cesiumColor
            .slice(0, 3)
            .map((c) => c / 255)
            .concat([cesiumColor[3] || 1]);
        return new Cesium.Color(...rgba);
    }

    // If value is string, attempt to convert to Cesium Color
    if (typeof cesiumColor === 'string') {
        // If CSS color value
        if (cesiumColor[0] === '#') {
            return Cesium.Color.fromCssColorString(cesiumColor);
        }
        // If any other string assume it's a cesium color string such as 'RED'
        // NOTE: This doesn't cause cesium to blow up, it simply displays as white.
        //       If we were to log a warning here, it'd case a massive spam of warnings as this is called frequently.
        return Cesium.Color[cesiumColor];
    }
    // If all else fails, return the value that was passed in as it may already be a Cesium Color
    return cesiumColor;
}

export function createGradientColorConfig(
    lowValue: number,
    lowColor: Color,
    highValue: number,
    highColor: Color,
): ColorConfig {
    return {
        type: 'gradient',
        points: [
            {
                value: lowValue,
                color: lowColor,
            },
            {
                value: highValue,
                color: highColor,
            },
        ],
        default: IMS_WHITE,
        reverse: false,
    };
}
